import { useQuickPrompts as useQuickPromptsBase } from "@noa/ui";
import { useAppConfigs } from "~/hooks/use-app-configs";

export function useQuickPrompts() {
  const { appConfigs, isLoadingAppConfigs } = useAppConfigs();
  return useQuickPromptsBase(appConfigs, isLoadingAppConfigs);
}
